export default {
  mobile_message: 'For optimal usability, use a computer to view the interactive diagram.',
};
